import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./PageLoader.css";

function PageLoader() {
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 600);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  if (!loading) return null;

  return (
    <div className="page-loader-overlay">
      <div className="page-loader-bar"></div>
      <div className="page-loader-spinner">
        <div className="pl-ring"></div>
        <span>Loading...</span>
      </div>
    </div>
  );
}

export default PageLoader;
